import React from 'react';
import { PracticeTestNotificationDialog } from './PracticeTestNotificationDialog';

export const NotificationsModal: React.FC = () => {
    return (
        <>
            {/* <PracticeTestNotificationDialog /> */}
        </>
    );
};

export default NotificationsModal;
